import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { homeCarouselData } from "./HomeCaroselData";
import { useNavigate } from "react-router-dom";

const handleDragStart = (e) => e.preventDefault();

const HomeCarousel = () => {
  const navigate = useNavigate();

  const handleShopNowClick = (e, path) => {
    e.stopPropagation();
    navigate(path);
  };

  const items = homeCarouselData.map((item) => (
    <div className="relative h-[550px] w-full">
      <img
        className="h-full w-full object-cover"
        src={item.image}
        alt={item.title}
        onDragStart={handleDragStart}
        role="presentation"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg mb-4 tracking-wider">
          {item.title}
        </h1>
        <p className="text-lg md:text-2xl text-white font-medium mb-8 drop-shadow-md">
          {item.subtitle}
        </p>
        <button
          onClick={(e) => handleShopNowClick(e, item.path)}
          className="px-8 py-3 bg-organic-green text-white font-bold text-lg rounded hover:bg-white hover:text-organic-green transition-colors duration-300"
        >
          SHOP NOW
        </button>
      </div>
    </div>
  ));
  return (
    <AliceCarousel
      mouseTracking
      items={items}
      autoPlay
      infinite
      autoPlayInterval={5000}
      animationDuration={1000}
      disableButtonsControls
    />
  );
};

export default HomeCarousel;
